import PaginateModel from "@/model/paginate";
import api from "./api";
import { AxiosResponse } from "axios";
import Customer from "@/model/customer";

interface OrderHistoryParentList {
  orderHistories: [];
  paginate: PaginateModel;
}

class OrderApi extends api {
  constructor() {
    super();
    this.setup();
  }
  // async getHistory(query): Promise<OrderHistoryList> {
  //   const response = await this.getHttp().get<ResponseInterface>(
  //     "admin-customer/order-history",
  //     {
  //       params: query,
  //     }
  //   );
  //   const list: OrderHistory[] = [];
  //   response.data.data.map((customerDto) =>
  //     list.push(new OrderHistory(customerDto))
  //   );
  //   console.log(list[0]);
  //   const paginate = new PaginateModel(response.data.paginate.Orders);
  //   return {
  //     list,
  //     paginate,
  //   };
  // }

  async getHistoryParentRecord(query): Promise<OrderHistoryParentList> {
    const response = await this.getHttp().get<any>("orders", {
      params: query,
    });

    const result = response.data.data;

    // const paginate = new PaginateModel(parent_rows.pagination);
    const paginate = new PaginateModel({
      page: result.pagination.current_page,
      pageCount: result.pagination.last_pages,
      start: result.pagination.current_page,
      end: result.pagination.last_pages,
      count: result.pagination.total,
    });
    const orderHistories = result.order_histories;

    return {
      orderHistories,
      paginate,
    };
  }
  async getOrderHistoryLastUpdateTime(): Promise<string> {
    const response = await this.getHttp().get<any>("orders/last-update-time");
    console.log(response.data.data);
    return response.data.data;
  }

  async downloadPdf(shipmentList): Promise<any> {
    return await this.getHttp().get<any>("orders/download-pdf", {
      params: shipmentList,
      responseType: "blob",
    });
  }

  async getCustomerSupervisorName(query = {}): Promise<any> {
    const result = await this.getHttp().get<any>(
      "orders/customer-supervisor-names",{
        data: query
      }
    );

    return result.data.data;
  }
  // async getHistoryByCustomer(query): Promise<OrderHistoryList> {
  //   const response = await this.getHttp().get<ResponseInterface>(
  //     "customer/order-history",
  //     {
  //       params: query,
  //     }
  //   );
  //   const list: OrderHistory[] = [];
  //   response.data.data.map((customerDto) =>
  //     list.push(new OrderHistory(customerDto))
  //   );
  //   const paginate = new PaginateModel(response.data.paginate.Orders);
  //   return {
  //     list,
  //     paginate,
  //   };
  // }
  async view(id, okurijo_number): Promise<AxiosResponse> {
    return this.getHttp().get<Customer>(
      "/customer/order-history/" + id + "?okurijo_number=" + okurijo_number
    );
  }
  async updateOrder(data): Promise<AxiosResponse> {
    return this.getHttp().post("/customer/order-history/", data);
  }
  async deleteOrderItem(id): Promise<AxiosResponse> {
    return this.getHttp().delete("/customer/order-history/" + id);
  }
  async add(data): Promise<any> {
    return this.getHttp().post("/orders", data);
  }
  async delete(id): Promise<AxiosResponse> {
    return this.getHttp().delete("/orders/" + id);
  }

  async thanks(id): Promise<AxiosResponse> {
    return this.getHttp().get("/orders/" + id + "/thanks");
  }
}
export default new OrderApi();
